import { LanguageSlug } from '../enums/languageSlug.enum';
import { PageCategory } from '../enums/pageCategory.enum';
import { PageCategoryData } from '../interfaces/pageCategoryData.types';

export const getBaseUrlByCategory = (categories: PageCategoryData[]) => {
  const projectCategory = process.env.PROJECT_CATEGORY;
  if (!!categories.find((category: PageCategoryData) => projectCategory === category.name)) {
    return '';
  } else if (categories[0].name === PageCategory.MainPage) {
    return process.env.MAIN_URL;
  } else if (categories[0].name === PageCategory.BiomasserPage) {
    return process.env.BIOMASSER_URL;
  } else if (categories[0].name === PageCategory.TomasserPage) {
    return process.env.TOMASSER_URL;
  } else {
    return '';
  }
};

export const getLanguagePrefix = (language: LanguageSlug) => {
  return `${language === LanguageSlug.Pl ? '' : language + '/'}`;
}
